import Immutable, { Map, List } from 'immutable';
import { createStore, getActionIds } from '../helpers/redux';
import { ElementActions } from '../actions/element';
import { ElementTypeActions } from '../actions/elementType';
import { ProjectActions } from '../actions/project';
import { RelationshipActions } from '../actions/relationship';

const elementActions = getActionIds(ElementActions);
const projectActions = getActionIds(ProjectActions);
const elementTypeActions = getActionIds(ElementTypeActions);
const relationshipActions = getActionIds(RelationshipActions);

const initialState = Immutable.fromJS({
  elementsRelationships: {
    // elementId: {
    //   providesTo: [1,2,3],
    //   consumesFrom: {},
    // }
  },
  loading: {
    elements: [],
    tags: [],
    comments: [],
  },
  loaded: {
    elements: [],
    tags: [],
    comments: [],
  },
  // status: {
  //   tags: {
  //     1: 'loading'
  //   }
  // }
});

export const elementsRelationships = createStore(initialState, {
  [projectActions.resetReducers]: (state, action) => {
    return initialState;
  },

  '*': (state, action) => {
    // if (action.result && action.result.entities && action.result.entities.relationships) {
    //   return Object.keys(action.result.entities.relationships).reduce((p, relId) => {
    //     const rel = action.result.entities.relationships[relId];
    //     const currentConsumerConsumesFrom = p.getIn(['elementsRelationships', rel.consumer, 'consumesFrom'], List()); //.push(relId);
    //     const currentProviderProvidesTo = p.getIn(['elementsRelationships', rel.producer, 'providesTo'], List()); //.push(relId);

    //     const newConsumerConsumesFrom = currentConsumerConsumesFrom.indexOf(relId) === -1 ?
    //       currentConsumerConsumesFrom.push(relId) : currentConsumerConsumesFrom;
    //     const newProviderProvidesTo = currentProviderProvidesTo.indexOf(relId) === -1 ?
    //       currentProviderProvidesTo.push(relId) : currentProviderProvidesTo;

    //     const consumerProvidesTo = p.getIn(['elementsRelationships', rel.consumer, 'providesTo'], List());
    //     const providerConsumesFrom = p.getIn(['elementsRelationships', rel.provider, 'consumesFrom'], List());

    //     return p.mergeDeep({
    //       elementsRelationships: {
    //         [rel.consumer]: {
    //           providesTo: consumerProvidesTo,
    //           consumesFrom: newConsumerConsumesFrom,
    //         },
    //         [rel.producer]: {
    //           providesTo: newProviderProvidesTo,
    //           consumesFrom: providerConsumesFrom,
    //         },
    //       },
    //     });
    //   }, state);
    // }
    // return state;

    if (
      action.type !== projectActions.getRootElement.success &&
      action.result &&
      action.result.entities &&
      action.result.entities.elements
    ) {
      let tempState = state.getIn(['elementsRelationships']);

      Object.keys(action.result.entities.elements).forEach(id => {
        const providesToList = tempState.getIn([id, 'providesTo'], []);
        const consumesFromList = tempState.getIn([id, 'consumesFrom'], []);

        if (action.result.entities.providesTo) {
          Object.keys(action.result.entities.providesTo).forEach(relId => {
            if (action.result.entities.providesTo[relId].producer === id) {
              providesToList.push(relId);
            }
          });
        }

        if (action.result.entities.consumesFrom) {
          Object.keys(action.result.entities.consumesFrom).forEach(relId => {
            if (action.result.entities.consumesFrom[relId].consumer === id) {
              consumesFromList.push(relId);
            }
          });
        }

        tempState = tempState.set(
          id,
          Immutable.fromJS({
            providesTo: providesToList,
            consumesFrom: consumesFromList,
          }),
        );
      });

      return state.set('elementsRelationships', Immutable.fromJS(tempState));
    }
    return state;
  },

  [elementTypeActions.getElementsByType.begin]: (state, action) => {
    const typeId = action.args[0];

    if (state.getIn(['loaded', 'elements']).indexOf(typeId) < 0) {
      return state.setIn(
        ['loading', 'elements'],
        state.getIn(['loading', 'elements']).push(typeId),
      );
    } else {
      return state;
    }
  },

  [elementTypeActions.getElementsByType.failure]: (state, action) => {
    const i = state.getIn(['loading', 'elements']).indexOf(action.args[0]);

    if (i > -1) {
      return state.deleteIn(['loading', 'elements', i]);
    } else {
      return state;
    }
  },

  [elementTypeActions.getElementsByType.success]: (state, action) => {
    const typeId = action.args[0];
    const i = state.getIn(['loading', 'elements']).indexOf(action.args[0]);

    if (i > -1) {
      return state
        .deleteIn(['loading', 'elements', i])
        .setIn(
          ['loaded', 'elements'],
          state.getIn(['loaded', 'elements']).push(typeId),
        );
    } else {
      return state;
    }
  },

  // [elementActions.getElement.success]: (state, action) => {
  //   let providesToList = [];
  //   let consumesFromList = [];

  //   if (action.result.entities.providesTo) {
  //     Object.keys(action.result.entities.providesTo).forEach((relId) => {
  //       if(action.result.entities.providesTo[relId].producer == action.result.result){
  //         providesToList.push(relId);
  //       }
  //     });
  //   }

  //   if (action.result.entities.consumesFrom) {
  //     Object.keys(action.result.entities.consumesFrom).forEach((relId) => {
  //       if(action.result.entities.consumesFrom[relId].consumer == action.result.result){
  //         consumesFromList.push(relId);
  //       }
  //     });
  //   }

  //   return state.mergeDeep({
  //     elementsRelationships: {
  //       [action.result.result]: {
  //         providesTo: providesToList,
  //         consumesFrom: consumesFromList
  //       }
  //     }
  //   });
  // },

  [elementActions.clientDeleteElements]: (state, action) => {
    const relLookup = action.relationshipMap.reduce(
      (prev, cur) =>
        prev.concat(cur.get('consumesFrom')).concat(cur.get('providesTo')),
      List(),
    );

    return state.get('elementsRelationships').reduce((prev, cur, key) => {
      if (action.elementIds.indexOf(key) > -1)
        return prev.deleteIn(['elementsRelationships', key]);

      const consumesFrom = cur.get('consumesFrom');
      const providesTo = cur.get('providesTo');

      const consumesFromIndex = consumesFrom.filter(ele => {
        return relLookup.indexOf(ele) === -1;
      });
      const providesToIndex = providesTo.filter(ele => {
        return relLookup.indexOf(ele) === -1;
      });

      return prev
        .setIn(
          ['elementsRelationships', key, 'consumesFrom'],
          consumesFromIndex,
        )
        .setIn(['elementsRelationships', key, 'providesTo'], providesToIndex);
    }, state);
  },

  [elementActions.deleteElement.success]: (state, action) => {
    return state;
  },

  [relationshipActions.deleteRelationships.success]: (state, action) => {
    action.result.relationships.forEach(rel => {
      let consumesFrom = state.getIn([
        'elementsRelationships',
        rel.consumer,
        'consumesFrom',
      ]);
      let providesTo = state.getIn([
        'elementsRelationships',
        rel.producer,
        'providesTo',
      ]);

      if (!consumesFrom) {
        consumesFrom = List();
      }
      if (!providesTo) {
        providesTo = List();
      }

      const relId = rel.id || rel.relId;

      const consumerConsumesIndex = consumesFrom.findIndex(v => v === relId);
      if (consumerConsumesIndex > -1)
        consumesFrom = consumesFrom.delete(consumerConsumesIndex);

      const producerProvidesToIndex = providesTo.findIndex(v => v === relId);
      if (producerProvidesToIndex > -1)
        providesTo = providesTo.delete(producerProvidesToIndex);

      state = state
        .setIn(
          ['elementsRelationships', rel.consumer, 'consumesFrom'],
          consumesFrom,
        )
        .setIn(
          ['elementsRelationships', rel.producer, 'providesTo'],
          providesTo,
        );
    });

    return state;
  },

  [relationshipActions.patchRelationships.success]: (state, action) => {
    if (
      action.result &&
      action.result.entities &&
      action.result.entities.relationships
    ) {
      const rels = action.result.entities.relationships;

      Object.keys(rels).forEach(id => {
        const rel = rels[id];

        if (rel.deleted_at) {
          let consumesFrom = state.getIn([
            'elementsRelationships',
            rel.consumer,
            'consumesFrom',
          ]);
          let providesTo = state.getIn([
            'elementsRelationships',
            rel.producer,
            'providesTo',
          ]);

          if (!consumesFrom) {
            consumesFrom = List();
          }
          if (!providesTo) {
            providesTo = List();
          }

          const relId = rel.id || rel.relId;

          const consumerConsumesIndex = consumesFrom.findIndex(
            v => v === relId,
          );

          if (consumerConsumesIndex > -1) {
            consumesFrom = consumesFrom.delete(consumerConsumesIndex);
          }
          const producerProvidesToIndex = providesTo.findIndex(
            v => v === relId,
          );
          if (producerProvidesToIndex > -1) {
            providesTo = providesTo.delete(producerProvidesToIndex);
          }
          state = state
            .setIn(
              ['elementsRelationships', rel.consumer, 'consumesFrom'],
              consumesFrom,
            )
            .setIn(
              ['elementsRelationships', rel.producer, 'providesTo'],
              providesTo,
            );
        } else {
          const consumerId = rel.consumer;
          const producerId = rel.producer;
          const relId = rel.id || rel.relId;
          let consumesFromArray;
          let providesToArray;

          try {
            consumesFromArray = state.getIn(
              ['elementsRelationships', consumerId, 'consumesFrom'],
              List(),
            );
            if (consumesFromArray.indexOf(relId) === -1) {
              consumesFromArray = consumesFromArray.push(relId);
            }
          } catch (e) {
            consumesFromArray = List();
          }
          // Get existing providesTo (for consumer) or empty List
          const consumerProvidesToArray = state.getIn(
            ['elementsRelationships', consumerId, 'providesTo'],
            List(),
          );

          try {
            providesToArray = state.getIn(
              ['elementsRelationships', producerId, 'providesTo'],
              List(),
            );
            if (providesToArray.indexOf(relId) === -1) {
              providesToArray = providesToArray.push(relId);
            }
          } catch (e) {
            providesToArray = List();
          }
          // Get existing consumesFrom (for producer) or empty List
          const producerConsumesFromArray = state.getIn(
            ['elementsRelationships', producerId, 'consumesFrom'],
            List(),
          );

          // Update consumer
          state = state
            .setIn(
              ['elementsRelationships', consumerId, 'consumesFrom'],
              consumesFromArray,
            )
            .setIn(
              ['elementsRelationships', consumerId, 'providesTo'],
              consumerProvidesToArray,
            );

          // Update producer
          state = state
            .setIn(
              ['elementsRelationships', producerId, 'providesTo'],
              providesToArray,
            )
            .setIn(
              ['elementsRelationships', producerId, 'consumesFrom'],
              producerConsumesFromArray,
            );
        }
      });
    }
    return state;
  },

  [relationshipActions.createRelationships.success]: (state, action) => {
    // let newElementsRelationships = state.getIn(['elementsRelationships']);
    let tempState = state;

    if (!action.result) return state;

    action.result.result.forEach(rel => {
      const consumerId = action.result.entities.relationships[rel].consumer;
      const producerId = action.result.entities.relationships[rel].producer;
      const relId = action.result.entities.relationships[rel].id;

      // Update consumesFrom and providesTo must handle two edge cases:
      // - the arrays must be created if they don't exist
      // - skip update if the id is already present in the array

      let consumesFromArray;
      let providesToArray;

      // Update both consumesFrom and providesTo for consumerId
      consumesFromArray = tempState.getIn(
        ['elementsRelationships', consumerId, 'consumesFrom'],
        List()
      );
      if (consumesFromArray.indexOf(relId) === -1) {
        consumesFromArray.push(relId);
      }
      providesToArray = tempState.getIn(
        ['elementsRelationships', consumerId, 'providesTo'],
        List(),
      );
      tempState = tempState.setIn(
        ['elementsRelationships', consumerId, 'consumesFrom'],
        consumesFromArray,
      );
      tempState = tempState.setIn(
        ['elementsRelationships', consumerId, 'providesTo'],
        providesToArray,
      );

      // Update both consumesFrom and providesTo for producerId
      consumesFromArray = tempState.getIn(
        ['elementsRelationships', producerId, 'consumesFrom'],
        List(),
      );
      providesToArray = tempState.getIn(
        ['elementsRelationships', producerId, 'providesTo'],
        List()
      );
      if (providesToArray.indexOf(relId) === -1) {
        providesToArray.push(relId);
      }
      tempState = tempState.setIn(
        ['elementsRelationships', producerId, 'consumesFrom'],
        consumesFromArray,
      );
      tempState = tempState.setIn(
        ['elementsRelationships', producerId, 'providesTo'],
        providesToArray,
      );
    });

    return tempState;
  },

  [relationshipActions.deleteRelationship.success]: (state, action) => {
    let elementsRelationships = state.get('elementsRelationships');
    const edgeToDelete = action.result.relationship.id;
    const producer = action.result.relationship.producer.id
      ? action.result.relationship.producer.id
      : action.result.relationship.producer;
    const consumer = action.result.relationship.consumer.id
      ? action.result.relationship.consumer.id
      : action.result.relationship.consumer;
    const elementsList = [producer, consumer];

    elementsList.forEach(elementId => {
      if (elementsRelationships.hasIn([elementId, 'consumesFrom'])) {
        const provideToIdx = elementsRelationships
          .getIn([elementId, 'consumesFrom'])
          .indexOf(edgeToDelete);
        if (provideToIdx !== -1) {
          elementsRelationships = elementsRelationships.deleteIn([
            elementId,
            'consumesFrom',
            provideToIdx,
          ]);
        }
      }
      if (elementsRelationships.hasIn([elementId, 'providesTo'])) {
        const consumesFromIdx = elementsRelationships
          .getIn([elementId, 'providesTo'])
          .indexOf(edgeToDelete);
        if (consumesFromIdx !== -1) {
          elementsRelationships = elementsRelationships.deleteIn([
            elementId,
            'providesTo',
            consumesFromIdx,
          ]);
        }
      }
    });

    return state.setIn(['elementsRelationships'], elementsRelationships);
  },

});

export const elementsRelationshipsSelector = state =>
  state.elementsRelationships.get('elementsRelationships', Map());

export const elementsRelationshipsStateSelector = state =>
  state.elementsRelationships;

export const loadedAllElementTypes = (
  taskTypeId,
  milestoneTypeId,
  elementsRelationshipsState,
) => {
  const loadedState = elementsRelationshipsState.getIn(['loaded', 'elements']);

  return (
    loadedState.indexOf(taskTypeId) > -1 &&
    loadedState.indexOf(milestoneTypeId) > -1
  );
};



// WEBPACK FOOTER //
// ./src/reducers/elementsRelationships.js